import React, { useEffect, useState } from "react";
import { MenuMap } from "./MenuMap";
import { MapWithTiles } from "./MapWithTiles";
import { risksList, urbanismeList } from "../../utils/staticInfos";
import { mountFormattedOverlay, toSlug } from "../../utils/overlaysUtils";
import { ImmobilierMenu } from "./ImmobilierMenu";
import { ImmobilierMap } from "./ImmobilierMap";
import {Caption} from "./Caption";

export const MapWidget = ({summary, sectionId, outlineCity, address, infosForImmo, features}) => {
    const [menuGroups, setMenuGroups] = useState(null);
    const [selectedItem, setSelectedItem] = useState({});
    const [immoItem, setImmoItem] = useState(infosForImmo);
    const [immoFailed, setImmoFailed] = useState(false);
    const [legendsValues, setLegendValues] = useState(undefined);
    const baseUrl = window.location.href.split('#')[0];

    useEffect(() => {
        let list;
        //function to get item according to url hash or first valid item
        let getActiveItem;

        switch (sectionId) {
            case 'risques':
                list = risksList
                    .map(group => ({
                        label: group.label,
                        items: group.items
                            .filter(i => i.isActive(features))
                            .map(i => mountFormattedOverlay(i, summary))
                    }))
                    .filter(group => group.items.length > 0)

                getActiveItem = (hash) => list.flatMap(group => group.items).find(i => toSlug(i.id) === hash) || list[0].items.find(i => !i.hasMissingData && !i.disabled);
                break;
            case 'urbanisme':
                list = urbanismeList
                    .map(group => ({
                            label: group.label,
                            items: group.items
                                .filter(i => i.isActive(features))
                                .map(i => mountFormattedOverlay(i, summary))
                    }))
                    .filter(group => group.items.length > 0)

                getActiveItem = (hash) => list.flatMap(group => group.items).find(i => toSlug(i.id) === hash) || list[0].items.find(i => !i.hasMissingData && !i.disabled);
                break;
            default:
                break;
        }

        //init first slash
        if(sectionId !== 'immobilier'){
            const urlParams = new URL(window.location.href);
            const searchParams = urlParams.search;
            const pathSegments = urlParams.pathname.split('/').filter(segment => segment);

            const itemSlug = searchParams.length > 0
                ? pathSegments[pathSegments.length - 1]
                : pathSegments[pathSegments.length - 2];

            let activeItem = getActiveItem(itemSlug);

            if (activeItem && !activeItem.disabled) {
                setSelectedItem(activeItem);
                if (sectionId === 'risques' || sectionId === 'urbanisme') {
                    if (searchParams.length === 0) {
                        const code = pathSegments[pathSegments.length - 1];
                        history.replaceState({}, "", `/${sectionId}/${toSlug(activeItem.id)}/${code}`);
                    } else {
                        history.replaceState({}, "", `/${sectionId}/${toSlug(activeItem.id)}${searchParams}`);
                    }
                }
            }
        }else{
            const urlParams = new URL(window.location.href).searchParams;
            getEstimates(urlParams.get('type-habitat'), urlParams.get('surface'), true, (url) => history.replaceState({}, "", url));
        }


        //handle hash changes
        window.addEventListener('popstate', () => {
            if (sectionId !== 'immobilier') {
                const url = new URL(window.location.href);
                const urlParams = url.href.split('/').pop();
                let activeItem = getActiveItem(urlParams);
                if (activeItem && !activeItem.disabled) {
                    setSelectedItem(activeItem)
                }
            }
        });

        //handle params changes (immobilier)
        window.addEventListener('popstate', () => {
            if(sectionId === 'immobilier'){
                const urlParams = new URL(window.location.href).searchParams;
                getEstimates(urlParams.get('type-habitat'), urlParams.get('surface'), true, (url) => history.replaceState({}, "", url));
            }
        });

        setMenuGroups(list);
    }, [sectionId])

    const getEstimates = (typeHabitatParam, surfaceParam, refreshParams, historyFunction) => {
        const typeHabitat = ['maison', 'appartement'].includes(typeHabitatParam) ? typeHabitatParam : 'appartement';
        const surface = Number.isInteger(parseInt(surfaceParam)) ? parseInt(surfaceParam) : 50;

        fetch(`/api/estimates/${immoItem.codeInsee}?surface=${surface}&type_habitat=${typeHabitat}`)
            .then(res => {
                if (res.ok) {
                    return res.json();
                }
                throw new Error("Échec de la récupération des estimations immobilières");
            })
            .then(estimates => {
                setImmoItem({ ...immoItem, refreshParams, typeHabitat, surface, data: estimates });
            })
            .catch((error) => {
                console.warn(error.message);
                setImmoFailed(true);
            })
            .finally(() => {
                let url = new URL(baseUrl);
                url.searchParams.set('type-habitat', typeHabitat);
                url.searchParams.set('surface', surface);
                historyFunction(url);
            });
    }

    const onSelectedItem = (item) => {
        const currentUrl = new URL(window.location.href);
        const searchParams = currentUrl.search;

        const pathSegments = currentUrl.pathname.split('/');
        const baseCategory = pathSegments[1];

        setSelectedItem(item);

        if (searchParams.length === 0) {
            const codeInsee = currentUrl.pathname.split('/').pop();
            history.replaceState({}, "", `/${baseCategory}/${toSlug(item.id)}/${codeInsee}`);
        } else {
            history.replaceState({}, "", `/${baseCategory}/${toSlug(item.id)}${searchParams}`);
        }
    }

    const onSelectedImmoItem = (item) => {
        if(['maison', 'appartement'].includes(item.typeHabitat) && Number.isInteger(item.surface)){
            getEstimates(
                item.typeHabitat,
                item.surface,
                false,
                (url) => {
                    history.pushState({}, "", url);
                }
            );
        }
    }

    return (
        <div className="dashboard-infos-map">
            {menuGroups &&
                <>
                    {['risques', 'urbanisme'].includes(sectionId)  &&
                        <MapWithTiles
                            sectionId={sectionId}
                            selectedItem={selectedItem}
                            locationInfos={{com: summary.commune, address}}
                            outlineCity={outlineCity.COM}
                            onChangeLegend={(values) => setLegendValues(values)}
                        />
                    }
                    <MenuMap
                        menuGroups={menuGroups}
                        selectedItem={selectedItem}
                        onSelectedItem={onSelectedItem}
                        address={address}
                    />
                    <Caption
                        legendsValues={legendsValues}
                        selectedItem={selectedItem}
                        addressInfos={{com: summary.commune, address}}
                    />
                </>
            }
            {((immoItem && immoItem.data) || immoFailed) &&
                <>
                    <ImmobilierMap 
                        immoItem={immoItem}
                        locationInfos={{com: undefined, address}}
                        outlineCity={outlineCity}
                    />
                    <ImmobilierMenu
                        immoItem={immoItem}
                        onChangeItem={onSelectedImmoItem}
                        address={address}
                        failed={immoFailed}
                    />
                </>
            }
        </div>
    )
}